// ============================================================================
// GroupsStore - Manages Groups
// ============================================================================
// Events: 'group:created', 'group:error'
// ============================================================================

import { supabase } from 'app/auth/auth.js';
import { EventEmitter } from './event-emitter.js';

const GROUP_SELECT = 'id, group_name, portfolio_manager, profiles(full_name, short_name)';

class GroupsStore extends EventEmitter {
    /** Search groups, optionally filtering by query string */
    async searchGroups(query = '') {
        try {
            const { data, error } = await supabase
                .from('groups')
                .select(GROUP_SELECT)
                .order('group_name');
            if (error) throw error;

            const list = data || [];
            if (!query) return list;

            const q = query.toLowerCase();
            return list.filter(g => {
                const searchText = [
                    g.group_name || '',
                    g.profiles?.full_name || '',
                    g.profiles?.short_name || ''
                ].join(' ').toLowerCase();
                return searchText.includes(q);
            });
        } catch (error) {
            this.emit('group:error', error);
            return [];
        }
    }

    /** Create a new group */
    async createGroup({ portfolio_manager, group_name }) {
        try {
            const { data, error } = await supabase
                .from('groups')
                .insert({ portfolio_manager, group_name })
                .select(GROUP_SELECT)
                .single();
            if (error) throw error;
            this.emit('group:created', data);
            return data;
        } catch (error) {
            this.emit('group:error', error);
            throw error;
        }
    }
}

export { GroupsStore };
